module.exports = __webpack_public_path__ + "front/img/b45.9b28747e.jpg";